var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-container" }, [
    _c("div", { staticClass: "navbar-image" }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "landing-wrapper",
        staticStyle: {
          "min-height": "100vh !important",
          display: "flex",
          "flex-direction": "column",
        },
        attrs: { id: "landing-wrapper" },
      },
      [
        _c(
          "header",
          {
            staticClass: "header",
            staticStyle: { "justify-content": "center", display: "flex" },
            attrs: { id: "header" },
          },
          [
            _c(
              "nav",
              {
                staticStyle: {
                  "max-width": "1440px",
                  display: "flex",
                  "justify-content": "end",
                },
              },
              [
                _c("div", [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      attrs: { id: "login", name: "login" },
                      on: {
                        click: function ($event) {
                          return _vm.redirectTo("/portal/docs/")
                        },
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "\n                            Iniciar sesión\n                        "
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "main",
          {
            staticStyle: { flex: "1", "overflow-y": "auto" },
            attrs: { id: "main-content" },
          },
          [
            _c("div", { staticClass: "page-width" }, [
              _c(
                "section",
                { staticClass: "main-title", attrs: { id: "init" } },
                [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", { staticClass: "description-container" }, [
                    _c("div", { staticClass: "card-container" }, [
                      _c("h1", [
                        _vm._v(
                          "\n                                SARA\n                            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("h2", [
                        _vm._v(
                          "\n                                Tu agente analítico ideal\n                            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "button",
                          {
                            attrs: { id: "start", name: "start" },
                            on: {
                              click: function ($event) {
                                return _vm.redirectTo("/portal/docs")
                              },
                            },
                          },
                          [_vm._m(2)]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm._m(3),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("section", { attrs: { id: "informations" } }, [
                _c(
                  "div",
                  { staticClass: "card-container" },
                  _vm._l(_vm.informations, function (information) {
                    return _c("div", { staticClass: "card-info" }, [
                      _c("h1", {
                        staticClass: "card-title",
                        domProps: { innerHTML: _vm._s(information.title) },
                      }),
                      _vm._v(" "),
                      _c("p", {
                        staticClass: "card-text",
                        domProps: { innerHTML: _vm._s(information.content) },
                      }),
                    ])
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _vm._m(4),
              _vm._v(" "),
              _c(
                "section",
                { attrs: { id: "complements" } },
                _vm._l(_vm.complements, function (complement) {
                  return _c(
                    "div",
                    { staticClass: "card-container" },
                    _vm._l(complement, function (card) {
                      return _c(
                        "div",
                        {
                          staticClass: "card-complement",
                          on: {
                            click: function ($event) {
                              return _vm.redirectTo(card.to)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "card-header" }, [
                            _c("div", { staticClass: "card-image" }, [
                              _c("i", {
                                staticClass: "pi",
                                class: [card.icon],
                              }),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "card-content" }, [
                            _c("h1", { staticClass: "card-title" }, [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(card.title) +
                                  "\n                                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "card-text" }, [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(card.content) +
                                  "\n                                "
                              ),
                            ]),
                          ]),
                        ]
                      )
                    }),
                    0
                  )
                }),
                0
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _vm._m(5),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        attrs: {
          id: "iuvity",
          name: "iuvity",
          href: "https://www.iuvity.com/",
          target: "_blank",
        },
      },
      [
        _vm._v("\n                        iuvity\n                        "),
        _c("i", { staticClass: "pi icon-link1" }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "info-container" }, [
      _c("h1", [
        _vm._v(
          "\n                            OPTIMIZA TU LUCHA CONTRA EL FRAUDE\n                        "
        ),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("div", [
          _c("p", [
            _vm._v(
              "\n                                    Para mejorar los resultados de tu sistema antifraude actual, minimizar el tiempo y dinero que inviertes en detección y gestionar el fraude de tus canales.\n                                "
            ),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("div", { staticClass: "btn-text" }, [
        _c("span", [
          _vm._v(
            "\n                                                Empezar\n                                            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "btn-icon" }, [
        _c("i", { staticClass: "pi icon-arrow" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-container" }, [
      _c("img", { attrs: { src: "/illustration.svg" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("section", { attrs: { id: "descriptions" } }, [
      _c("div", { staticClass: "description-container" }, [
        _c("h1", [
          _vm._v(
            "\n                            El complemento ideal para tu solución antifraude\n                        "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("footer", { attrs: { id: "footer" } }, [
      _c("span", [_vm._v("\n                Powered by\n            ")]),
      _vm._v(" "),
      _c("i", { staticClass: "pi icon-iuvity" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }